export const PACKAGE_VERSION = "0.25.1-sqlite.13";
